import { render } from "./ImportPreviewCard.vue?vue&type=template&id=32c138e9"
import script from "./ImportPreviewCard.vue?vue&type=script&lang=js"
export * from "./ImportPreviewCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PHPStormProjects\\hqam-customer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__